import styled from "@emotion/styled";
import { Icon, personIcon } from "@repo/skapa";
import { useSettings } from "@repo/ui";

import {
  type CoWorkerCalendarItem,
  isCoWorkerCalendarBokaAppointment,
} from "../types";
import { getColor, getRenderTypeInfoFromCalendarItem } from "../utils";

export const DragContainer = styled.div<{ horizontal: boolean }>`
  position: absolute;

  top: 0;
  width: 100%;
  bottom: ${({ horizontal }) => (horizontal ? "0" : "2px")};
  right: ${({ horizontal }) => (horizontal ? "2px" : "")};

  cursor: pointer;
`;

export const ResizeContainer = styled.div<{ horizontal: boolean }>`
  position: absolute;

  height: ${({ horizontal }) => (horizontal ? "" : "2px")};
  width: ${({ horizontal }) => (horizontal ? "2px" : "100%")};
  bottom: ${({ horizontal }) => (horizontal ? "0" : "0")};
  right: ${({ horizontal }) => (horizontal ? "0" : "")};
  top: ${({ horizontal }) => (horizontal ? "0" : "")};

  cursor: ${({ horizontal }) => (horizontal ? "col-resize" : "row-resize")};
`;

export const InternalIcon = ({ item }: { item: CoWorkerCalendarItem }) => {
  const { task_configuration, calendar } = useSettings();
  if (!isCoWorkerCalendarBokaAppointment(item) || !item.internal) {
    return null;
  }
  const renderInfo = getRenderTypeInfoFromCalendarItem(item);

  return (
    <Icon
      paths={personIcon}
      color={
        getColor(
          renderInfo,
          task_configuration?.task_types,
          calendar?.activity_configuration
        ).textColor
      }
    />
  );
};
